module.exports = __webpack_public_path__ + "img/no-standing-scheduled-state.d67c3665.svg";